// Centralized navigation configuration
const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Community' },
  { to: '/contact', label: 'Contact' },
];

export default navLinks;
